export default __webpack_public_path__ + "static/media/MentalHealth.0657fe68.webp";